module.exports = __webpack_public_path__ + "static/media/viber_16px.4d0292d5.svg";